if (!customElements.get('band-pack-chooser')) {
  customElements.define(
    'band-pack-chooser',
    class BandPackChooser extends HTMLElement {
      constructor() {
        super();
        this.repositionOnMobile();
        this.bandVariantId = parseInt(this.dataset.bandVariantId, 10);
        this.bandPrice = parseInt(this.dataset.bandPrice, 10);

        this.optionInputs = this.querySelectorAll('input[name="band-pack-option"]');
        this.bottleWrap = this.querySelector('.band-pack__bottles');
        this.bottleFamilyInputs = this.querySelectorAll('input[name="band-pack-bottle-family"]');
        this.variantPickerPanel = this.querySelector('[data-band-pack-variant-picker]');
        this.variantGroupsEl = this.querySelector('[data-band-pack-variant-groups]');
        this.variantOosEl = this.querySelector('[data-band-pack-variant-oos]');
        this.variantThumbEl = this.querySelector('[data-band-pack-variant-thumb]');
        this.submitBtn = this.querySelector('[data-band-pack-submit]');
        this.submitLabel = this.querySelector('[data-band-pack-submit-label]');
        this.errorEl = this.querySelector('[data-band-pack-error]');

        this.selectedBottleVariantId = null;
        this.selectedBottleVariantPrice = 0;
        this.selectedBottleVariantAvailable = true;
        this.currentOptions = [];
        this.currentVariants = [];
        this.selectedValues = [];

        this.optionInputs.forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange());
        });
        this.bottleFamilyInputs.forEach((input) => {
          input.addEventListener('change', () => this.onBottleFamilyChange(input));
        });
        this.submitBtn.addEventListener('click', () => this.addToCart());

        const initialFamily = this.querySelector('input[name="band-pack-bottle-family"]:checked') || this.bottleFamilyInputs[0];
        if (initialFamily) this.renderVariantPicker(initialFamily);
        this.onOptionChange();
      }

      repositionOnMobile() {
        if (!window.matchMedia('(max-width: 767px)').matches) return;
        const metaAnchor = document.querySelector('.product-detail__meta');
        if (!metaAnchor) return;
        const sectionWrapper = this.closest('.shopify-section') || this;
        metaAnchor.insertAdjacentElement('afterend', sectionWrapper);
      }

      get selectedOptionInput() {
        return this.querySelector('input[name="band-pack-option"]:checked');
      }

      get selectedOption() {
        const checked = this.selectedOptionInput;
        return checked ? checked.value : 'duo';
      }

      onBottleFamilyChange(input) {
        this.renderVariantPicker(input);
      }

      renderVariantPicker(familyInput) {
        this.variantGroupsEl.innerHTML = '';
        this.variantOosEl.hidden = true;

        if (familyInput.dataset.singleVariantId) {
          this.variantPickerPanel.hidden = true;
          this.selectedBottleVariantId = parseInt(familyInput.dataset.singleVariantId, 10);
          this.selectedBottleVariantPrice = parseInt(familyInput.dataset.singleVariantPrice, 10);
          this.selectedBottleVariantAvailable = !familyInput.disabled;
          this.updateSubmitLabel();
          return;
        }

        let options = [];
        let variants = [];
        try {
          options = JSON.parse(familyInput.dataset.options || '[]');
          variants = JSON.parse(familyInput.dataset.variants || '[]');
        } catch (e) {
          options = [];
          variants = [];
        }

        if (!options.length || !variants.length) {
          this.variantPickerPanel.hidden = true;
          return;
        }

        this.currentOptions = options;
        this.currentVariants = variants;

        const defaultVariant = variants.find((v) => v.available) || variants[0];
        this.selectedValues = [defaultVariant.o1, defaultVariant.o2];

        options.forEach((opt, index) => {
          const group = document.createElement('div');
          group.className = 'band-pack__variant-group';

          const label = document.createElement('p');
          label.className = 'band-pack__variant-group-label';
          label.textContent = opt.name;
          group.appendChild(label);

          const pillsWrap = document.createElement('div');
          pillsWrap.className = 'band-pack__variant-pills';

          const isColorOption = opt.name === 'Color';

          opt.values.forEach((value) => {
            const pill = document.createElement('button');
            pill.type = 'button';
            pill.dataset.optionIndex = String(index);
            pill.dataset.value = value;

            if (isColorOption) {
              pill.className = 'band-pack__variant-pill band-pack__variant-pill--swatch';
              const swatch = document.createElement('span');
              swatch.className = 'band-pack__variant-swatch';
              if (this.isValidCssColor(value)) {
                swatch.style.backgroundColor = value;
              } else {
                const rep = this.findRepresentativeVariant(index, value);
                if (rep && rep.img) swatch.style.backgroundImage = `url('${rep.img}')`;
              }
              pill.appendChild(swatch);
              const labelSpan = document.createElement('span');
              labelSpan.className = 'band-pack__variant-pill-label';
              labelSpan.textContent = value;
              pill.appendChild(labelSpan);
            } else {
              pill.className = 'band-pack__variant-pill';
              pill.textContent = value;
            }

            if (this.selectedValues[index] === value) pill.classList.add('is-active');
            pill.addEventListener('click', () => this.onVariantPillClick(index, value));
            pillsWrap.appendChild(pill);
          });

          group.appendChild(pillsWrap);
          this.variantGroupsEl.appendChild(group);
        });

        this.variantPickerPanel.hidden = false;
        this.resolveVariant();
      }

      isValidCssColor(value) {
        const opt = new Option();
        opt.style.color = '';
        opt.style.color = value;
        return opt.style.color !== '';
      }

      findRepresentativeVariant(index, value) {
        const key = index === 0 ? 'o1' : 'o2';
        return this.currentVariants.find((v) => v[key] === value) || null;
      }

      onVariantPillClick(index, value) {
        this.selectedValues[index] = value;

        let match = this.currentVariants.find(
          (v) => v.o1 === this.selectedValues[0] && (this.selectedValues[1] === undefined || v.o2 === this.selectedValues[1])
        );
        if (!match) {
          // The clicked value doesn't exist alongside the other current selection
          // (e.g. a colour only available in the other size) — keep the clicked
          // value fixed and adjust the other option to the best matching variant.
          const key = index === 0 ? 'o1' : 'o2';
          match = this.currentVariants.find((v) => v[key] === value && v.available) || this.currentVariants.find((v) => v[key] === value);
          if (match) this.selectedValues = [match.o1, match.o2];
        }

        this.querySelectorAll('.band-pack__variant-pill').forEach((pill) => {
          const idx = parseInt(pill.dataset.optionIndex, 10);
          pill.classList.toggle('is-active', pill.dataset.value === this.selectedValues[idx]);
        });

        this.resolveVariant();
      }

      resolveVariant() {
        const match = this.currentVariants.find(
          (v) => v.o1 === this.selectedValues[0] && (this.selectedValues[1] === undefined || v.o2 === this.selectedValues[1])
        );
        if (match) {
          this.selectedBottleVariantId = match.id;
          this.selectedBottleVariantPrice = match.price;
          this.selectedBottleVariantAvailable = match.available;
          this.variantOosEl.hidden = match.available;
          if (this.variantThumbEl && match.img) {
            this.variantThumbEl.src = match.img;
            this.variantThumbEl.hidden = false;
          } else if (this.variantThumbEl) {
            this.variantThumbEl.hidden = true;
          }
        } else {
          this.selectedBottleVariantId = null;
          this.selectedBottleVariantPrice = 0;
          this.selectedBottleVariantAvailable = false;
          this.variantOosEl.hidden = false;
          if (this.variantThumbEl) this.variantThumbEl.hidden = true;
        }
        this.updateSubmitLabel();
      }

      currentTotalCents() {
        const option = this.selectedOption;
        if (option === 'single') return this.bandPrice;
        if (option === 'duo') return this.bandPrice * 2;
        return this.bandPrice + this.selectedBottleVariantPrice;
      }

      formatMoney(cents) {
        const format = (window.cartStrings && window.cartStrings.money_format) || '';
        return window.Shopify && typeof Shopify.formatMoney === 'function'
          ? Shopify.formatMoney(cents, format)
          : cents;
      }

      onOptionChange() {
        this.bottleWrap.hidden = this.selectedOption !== 'complete';
        this.updateSubmitLabel();
      }

      updateSubmitLabel() {
        const optionInput = this.selectedOptionInput;
        const label = optionInput ? optionInput.dataset.label : 'the Band Duo';
        this.submitLabel.textContent = `Add ${label} · ${this.formatMoney(this.currentTotalCents())}`;
      }

      buildItems() {
        const option = this.selectedOption;
        if (option === 'single') {
          return [{ id: this.bandVariantId, quantity: 1 }];
        }
        if (option === 'duo') {
          return [{ id: this.bandVariantId, quantity: 2 }];
        }
        const items = [{ id: this.bandVariantId, quantity: 1 }];
        if (this.selectedBottleVariantId) {
          items.push({ id: this.selectedBottleVariantId, quantity: 1 });
        }
        return items;
      }

      addToCart() {
        if (this.submitBtn.classList.contains('loading')) return;

        if (this.selectedOption === 'complete') {
          if (!this.selectedBottleVariantId) {
            this.errorEl.textContent = 'Please choose a bottle.';
            this.errorEl.hidden = false;
            return;
          }
          if (!this.selectedBottleVariantAvailable) {
            this.errorEl.textContent = 'That colour and size is out of stock — please pick another.';
            this.errorEl.hidden = false;
            return;
          }
        }

        this.errorEl.hidden = true;
        this.submitBtn.classList.add('loading');
        this.submitBtn.disabled = true;

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        this.buildItems().forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][quantity]`, item.quantity);
        });
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${window.routes.cart_add_url}.js`, config)
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.message) {
              this.errorEl.textContent = parsedState.description || parsedState.message;
              this.errorEl.hidden = false;
              return;
            }
            if (cart) {
              cart.getSectionsToRender().forEach((section) => {
                const elementToReplace = document.getElementById(section.id);
                if (!elementToReplace || !parsedState.sections || !parsedState.sections[section.id]) return;
                const html = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
                const newContent = html.querySelector('#minicart-form');
                if (newContent) elementToReplace.innerHTML = newContent.innerHTML;
              });
              if (typeof cart.cartAction === 'function') cart.cartAction();
              if (typeof cart.setActiveElement === 'function') cart.setActiveElement(this.submitBtn);
              cart.open();
            }
            fetch('/cart.js')
              .then((res) => res.json())
              .then((cartData) => {
                if (cartData.item_count === undefined) return;
                document.querySelectorAll('.cart-count').forEach((el) => {
                  el.innerHTML = el.classList.contains('cart-count-drawer')
                    ? `(${cartData.item_count})`
                    : cartData.item_count > 100
                    ? '~'
                    : cartData.item_count;
                });
              })
              .catch(() => {});
          })
          .catch(() => {
            this.errorEl.textContent = 'Something went wrong adding this to your cart. Please try again.';
            this.errorEl.hidden = false;
          })
          .finally(() => {
            this.submitBtn.classList.remove('loading');
            this.submitBtn.disabled = false;
          });
      }
    }
  );
}
